import VentusSearch from './ventusSearch';
import HughesSearch from './hughesSearch';
import { LanguageContext } from '../../../context/languageContext';

export const utilities = translations => [
  {
    tab: 'Ventus',
    items: [
      {
        title: 'Ventus',
        description: 'Ventus Devices',
        component: <VentusSearch />,
      },
    ],
  },
  {
    tab: 'Hughes',
    items: [
      {
        title: 'Hughes',
        description: 'Hughes',
        component: <HughesSearch />,
      },
    ],
  },
];
